jQuery(function($){
    $('.top-links-menu-container .menu-item-has-children').append('<span class="submenu-toggle"></span>')
    $('.top-links-menu-container .submenu-toggle').on('click', submenuToggle)
    $('.top-links-menu-container .menu-item-has-children')
    .on('mouseenter', submenuHover)
    .on('mouseleave', submenuUnhover)
    
    function submenuToggle () {
        const containerLi = $(this).parent('.menu-item-has-children')
        const submenuOffsetLeft = getSubmenuOffsetLeft(containerLi)
        
        if($(containerLi).hasClass('show-submenu')) {
            //hide
            $(containerLi).find('.sub-menu').css('left', '')
            $(containerLi).find('.show-submenu').removeClass('show-submenu')
        } else {
            //show
            $(containerLi).children('.sub-menu').css('left', submenuOffsetLeft)
        }
        $(containerLi).toggleClass('show-submenu')
    }

    function submenuHover () {
        if(!$(this).hasClass('show-submenu')) {
            let submenuOffsetLeft = getSubmenuOffsetLeft(this)

            $(this).children('.sub-menu').css({'left': submenuOffsetLeft, 'display': 'block'})
        }
    }

    function submenuUnhover () {
        if(!$(this).hasClass('show-submenu')) {
            $(this).find('.sub-menu').removeAttr('style')
        }
    }

    function getSubmenuOffsetLeft (container) {
        let offsetLeft = $(container).offset().left
        const windowWidth = $(window).width()
        const elementWidth = $(container).children('.sub-menu').width()
        
        //check if submenu would go over window edge
        if(elementWidth + offsetLeft > windowWidth) {
            offsetLeft = -1 * (offsetLeft + elementWidth - windowWidth)
        } else {
            offsetLeft = 0
        }

        return offsetLeft
    }
})